import type { Provider } from '@angular/core';

import { DownloadInsightsCsvSummaryBaseService } from '#modules/statistics/services/csv-insights-summary/download-insights-summary-base.service';
import { DownloadInsightsSummaryService } from '#modules/statistics/services/csv-insights-summary/download-insights-summary.service';
import { CsvInsightsSummaryService } from '#modules/statistics/services/csv-summary/insights/summary.service';

export const DOWNLOAD_INSIGHTS_SUMMARY_PROVIDERS: Provider[] = [
    // Generic Service
    DownloadInsightsCsvSummaryBaseService,
    // Specific Services
    DownloadInsightsSummaryService,
    CsvInsightsSummaryService,
];
